/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

export default noop;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/noop.js
// module id = 169
// module chunks = 0